import { useEffect, useState } from "react";

import toast from "react-hot-toast";

import { getTenant } from "../../../utils/tenantManager";

import {
  getDueCalibrationCertificatesReportApi,
} from "../../../services/operation/reports/reportsApi";

export const useCalibrationsDueViewModel = () => {
  const tenantId = getTenant();

  // ============================================================
  // AUSTRALIA CURRENT DATE
  // ============================================================

  const getAustraliaCurrentDate = () => {
    const now = new Date();

    return new Intl.DateTimeFormat("en-CA", {
      timeZone: "Australia/Sydney",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(now);
  };

  // ============================================================
  // DEFAULT DATE
  // ============================================================

  const today = getAustraliaCurrentDate();

  // ============================================================
  // DATA
  // ============================================================

  const [calibrationCertificates, setCalibrationCertificates] =
    useState<any[]>([]);

  // ============================================================
  // LOADING
  // ============================================================

  const [loading, setLoading] = useState(false);

  // ============================================================
  // FILTERS
  // ============================================================

  // Default customer = All
  const [customerId, setCustomerId] = useState("");

  // Default dates = Australia current date
  const [startDate, setStartDate] = useState(today);

  const [endDate, setEndDate] = useState(today);

  // ============================================================
  // LOAD REPORT
  // ============================================================

  const loadReport = async (
    selectedCustomerId: string = "",
  ) => {
    try {
      setLoading(true);

      const customerIdValue =
        selectedCustomerId?.trim() || "";

      const res =
        await getDueCalibrationCertificatesReportApi(
          customerIdValue,
          startDate,
          endDate,
          tenantId!,
        );

      setCalibrationCertificates(
        res?.data || [],
      );
    } catch (err: any) {
      toast.error(
        err?.response?.data?.message ||
          "Failed to load calibration report",
      );

      setCalibrationCertificates([]);
    } finally {
      setLoading(false);
    }
  };

  // ============================================================
  // INITIAL LOAD
  // ============================================================

  useEffect(() => {
    loadReport("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ============================================================
  // SEARCH REPORT
  // ============================================================

  const searchReport = async (
    selectedCustomerId: string = "",
  ) => {
    const customerIdValue =
      selectedCustomerId?.trim() || "";

    setCustomerId(customerIdValue);

    await loadReport(customerIdValue);
  };

  // ============================================================
  // CLEAR FILTERS
  // ============================================================

  const clearFilters = async () => {
    const currentAustraliaDate =
      getAustraliaCurrentDate();

    setCustomerId("");

    setStartDate(currentAustraliaDate);

    setEndDate(currentAustraliaDate);

    try {
      setLoading(true);

      const res =
        await getDueCalibrationCertificatesReportApi(
          "",
          currentAustraliaDate,
          currentAustraliaDate,
          tenantId!,
        );

      setCalibrationCertificates(
        res?.data || [],
      );
    } catch (err: any) {
      toast.error(
        err?.response?.data?.message ||
          "Failed to clear report",
      );

      setCalibrationCertificates([]);
    } finally {
      setLoading(false);
    }
  };

  // ============================================================
  // RETURN
  // ============================================================

  return {
    // DATA
    calibrationCertificates,

    // LOADING
    loading,

    // FILTERS
    customerId,
    setCustomerId,

    startDate,
    setStartDate,

    endDate,
    setEndDate,

    // ACTIONS
    loadReport,
    searchReport,
    clearFilters,
  };
};